"use client";

import { useState, useEffect, useRef } from "react";
import NewsVideoCard from "./NewsVideoCard";
import CustomSlider from "./ui/CustomSlider/CustomSlider";
import { formatDuration } from "@/app/utilities/helper";
import Heading from "./ui/Heading";
import ViewAllLink from "./ui/ViewAllLink";
import { TRACKING } from "@/lib/constants/tracking";

type VideoSectionProps = {
  isMobile: boolean;
  videos: any[];
  showViewAllLink?: boolean;
  heading?: string;
  itemsToShow?: number;
};

const VideoSection: React.FC<VideoSectionProps> = ({ isMobile, videos, showViewAllLink, heading,itemsToShow = 4 }) => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState<number | null>(null);
  const sectionId = useRef(Math.random().toString());

  useEffect(() => {
    const handleGlobalPlay = (e: any) => {
      if (e.detail?.sectionId !== sectionId.current) {
        setPlayingVideoIndex(null);
      }
    };
    window.addEventListener('globalVideoPlay', handleGlobalPlay);
    return () => {
      window.removeEventListener('globalVideoPlay', handleGlobalPlay);
    };
  }, []);

  const handleVideoPlay = (index: number) => {
    setPlayingVideoIndex(index);
    window.dispatchEvent(new CustomEvent('globalVideoPlay', { detail: { sectionId: sectionId.current } }));
  };

  if(!videos?.length){
    return null;
  }

  return (
    <div className={`${TRACKING.VIDEO_PLAYER.LONG_VIDEO_SECTION} pb-[10px] md:pb-[58px]`} id="videos-section">
      <Heading tag="h2" className="mb-6 font-bold">
        {heading || "Latest Videos"}
      </Heading>

      {videos.length > itemsToShow ? (
        <CustomSlider
          itemsToShow={isMobile ? 1.1 : itemsToShow}
          responsive={{
            desktop: itemsToShow,
            tablet: 2,
            mobile: 1.1,
          }}
          showArrows={true}
          nextBtnTrackingClass={TRACKING.VIDEO_PLAYER.LONG_VIDEO_NEXT}
          prevBtnTrackingClass={TRACKING.VIDEO_PLAYER.LONG_VIDEO_PREV}
          className={isMobile? TRACKING.VIDEO_PLAYER.LONG_VIDEO_CAROUSEL: ""}
        >
          {videos.map((video, index) => (
            <div key={index}>
              <NewsVideoCard
                title={video.title}
                imageUrl={video.custom_thumbnail_url ? video.custom_thumbnail_url : video.thumbnail_url}
                alt={video.title}
                duration={formatDuration(video.duration_seconds)}
                videoUrl={video.video_url}
                excerpt={video.excerpt}
                displayDate={video.created_at || video.publish_date || video.createdAt}
                isPlaying={playingVideoIndex === index}
                onPlay={() => handleVideoPlay(index)}
                isMobile={isMobile}
              />
            </div>
          ))}
        </CustomSlider>
      ) : (
        <div className="flex gap-4 overflow-x-auto md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 md:grid -mx-[18px] px-[18px] md:mx-0 md:px-0 scrollbar-hide scrollbar-hide">
          {videos.map((video, index) => (
            <div
                key={index}
                className="flex-none w-[90%] md:w-auto"
            >
              <NewsVideoCard

                title={video.title}
                imageUrl={video.custom_thumbnail_url ? video.custom_thumbnail_url : video.thumbnail_url}
                alt={video.title}
                duration={formatDuration(video.duration_seconds)}
                videoUrl={video.video_url}
                excerpt={video.excerpt}
                displayDate={video.created_at || video.publish_date || video.createdAt}
                isPlaying={playingVideoIndex === index}
                onPlay={() => handleVideoPlay(index)}
                isMobile={isMobile}
              />
            </div>
          ))}
        </div>
      )}

      {/* <ViewAllLink href="/videos" label="View All Videos" /> */}
    </div>
  );
};

export default VideoSection;
